/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type DisplayNotesTypes } from '@/api/types/browse-search-types';

type Props = {
  techNote?: string;
  quickNote?: string;
  displayNotesTypes?: DisplayNotesTypes;
};

/**
 * Concatenates the display notes for PDP, search and shelf pages separated by a comma.
 * @param techNote only exists in PartsPro
 * @param quickNote only exists in PartsPro
 * @param displayNotesTypes only exists in ACES - contains all note types (Fitment, Informational, Product, Installation, Caution, OE Only, Emmision)
 * @returns `${quickNote}, ${techNote}` or `${displayNotesTypes.Fitment[0]}, ..., ${displayNotesTypes.Fitment[n]}` or empty string if no notes exist
 */

export const getFormattedDisplayNotes = ({
  techNote,
  quickNote,
  displayNotesTypes,
}: Props): string => {
  const displayNotes = displayNotesTypes
    ? Object.values(displayNotesTypes)
        .flatMap((noteArray: unknown) =>
          Array.isArray(noteArray)
            ? noteArray.filter((item): item is string => typeof item === 'string')
            : []
        )
        .join(', ')
    : '';
  return displayNotes || [quickNote, techNote].filter(Boolean).join(', ');
};
